export default __webpack_public_path__ + "static/media/logo.56d7856d.svg";